import DOMPurify from 'dompurify';

// Duyuru/prosedür gibi zengin metin içeriklerini dangerouslySetInnerHTML'e vermeden önce temizler.
// Script, event handler (onerror vb.) ve javascript: linkleri kaldırılır; biçimlendirme korunur.
export const sanitizeHtml = (html: string | null | undefined): string =>
  DOMPurify.sanitize(html || '', { ADD_ATTR: ['target'] });

// Önizleme için içeriği kısaltır. Kesme HTML etiketinin ortasına denk gelebildiğinden
// temizleme kısaltmadan sonra yapılır (DOMPurify yarım kalan etiketleri de düzeltir).
export const sanitizeHtmlPreview = (html: string | null | undefined, maxLength: number): string => {
  const content = html || '';
  return sanitizeHtml(content.length > maxLength ? content.substring(0, maxLength) + '...' : content);
};
